'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/monthly-cash-desk', {
      template: require('./monthlyReport.pug'),
      controller: 'MonthlyReportController',
      controllerAs: 'monthlyReport',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/monthlyReport/monthlyReport.routes.ts